var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_992)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22897 10.8723C7.34463 11.0458 7.1133 11.3349 6.82415 11.5084C6.47716 11.6819 6.07234 11.6819 6.01451 11.5084L4.85788 9.65784C4.74222 9.48434 4.91571 9.19519 5.2627 9.02169C5.60969 8.8482 5.95668 8.8482 6.07234 9.02169L7.22897 10.8723ZM18.2747 13.9952C17.5229 11.7976 17.176 6.30362 16.3663 5.03133C14.5157 2.08193 10.294 1.0988 6.99764 2.89157C3.64342 4.68434 2.42897 8.50121 4.27957 11.4506C5.08921 12.7807 10.1205 15.8458 11.7398 17.4651L18.2747 13.9952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7133 21.9759C16.7133 21.9759 16.9446 22.0337 17.1181 21.9181L19.7205 20.5301C19.894 20.4145 20.0097 20.2988 19.9519 20.1831L19.6049 19.6627L16.3663 21.3976L16.7133 21.9759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7374 14.9205C18.6217 14.9205 18.4482 14.9205 18.2747 15.0361L12.6651 18.0434C12.5494 18.1012 12.4338 18.2169 12.3759 18.3325C12.2603 18.5638 12.2603 18.7952 12.3759 19.0265L14.053 21.1084C14.2844 21.4554 14.747 21.5711 15.094 21.3397L20.1832 18.6217C20.5301 18.4482 20.7036 17.9855 20.4723 17.6964L19.3735 15.2675C19.2 15.0361 18.9687 14.9205 18.7374 14.9205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconOn);
export default __webpack_public_path__ + "static/media/DashboardIconOn.4c42d5fa9df047423765ae48960ffa70.svg";
export { ForwardRef as ReactComponent };